// tool type, 0: for both prefix and AS, 1: only for prefix, 2: only for AS
export const TOOL_TYPE = {
  PREFIX_AND_AS: 0,
  PREFIX: 1,
  AS: 2,
};

export default {
  All: [
    {
      id: 'routing-status',
      name: 'Routing Status',
      type: TOOL_TYPE.PREFIX_AND_AS,
    },
    {
      id: 'bgp-update-activity',
      name: 'BGP Update Activity',
      type: TOOL_TYPE.PREFIX_AND_AS,
    },
    {
      id: 'routing-history',
      name: 'Routing History',
      type: TOOL_TYPE.PREFIX_AND_AS,
    },
    {
      id: 'announced-prefixes',
      name: 'Announced Prefixes',
      type: TOOL_TYPE.AS,
    },
    { id: 'as-path-length', name: 'AS Path Length', type: TOOL_TYPE.AS },
    { id: 'asn-neighbours', name: 'ASN Neighbour', type: TOOL_TYPE.AS },
    {
      id: 'asn-neighbours-history',
      name: 'ASN Neighbours History',
      type: TOOL_TYPE.AS,
    },
    { id: 'prefix-count', name: 'Prefix Count', type: TOOL_TYPE.AS },
    { id: 'visibility', name: 'Visibility', type: TOOL_TYPE.PREFIX_AND_AS },
    {
      id: 'prefix-size-distribution',
      name: 'Prefix Size Distribution',
      type: TOOL_TYPE.AS,
    },
    {
      id: '-routing-consistency',
      name: 'AS/Prefix Routing Consistency',
      type: TOOL_TYPE.PREFIX_AND_AS,
    },
    { id: 'bgplay', name: 'BGPlay', type: TOOL_TYPE.PREFIX },
    {
      id: 'related-prefixes',
      name: 'Related Prefixes',
      type: TOOL_TYPE.PREFIX,
    },
    {
      id: 'upstream-visibility',
      name: 'Upstream visibility',
      type: TOOL_TYPE.PREFIX,
    },
    {
      id: 'caida-as-relationships',
      name: 'Caida AS Relationships',
      type: TOOL_TYPE.AS,
    },
    {
      id: '-overview',
      name: 'AS/Prefix Overview',
      type: TOOL_TYPE.PREFIX_AND_AS,
    },
    {
      id: 'atlas-probes',
      name: 'RIPE Atlas Probes',
      type: TOOL_TYPE.PREFIX_AND_AS,
    },
    {
      id: 'atlas-targets',
      name: 'RIPE Atlas Measurement Targets',
      type: TOOL_TYPE.PREFIX_AND_AS,
    },
    {
      id: 'atlas-probe-deployment',
      name: 'RIPE Atlas Probe Deployment',
      type: TOOL_TYPE.AS,
    },
    {
      id: 'bandwidth',
      name: 'Observed Bandwidth Capacity',
      type: TOOL_TYPE.PREFIX,
    },
    {
      id: 'network-activity',
      name: 'Observed Network Activity',
      type: TOOL_TYPE.PREFIX,
    },
  ],
  'Routing tools': [
    {
      id: 'routing-status',
      name: 'Routing Status',
      type: TOOL_TYPE.PREFIX_AND_AS,
    },
    {
      id: 'bgp-update-activity',
      name: 'BGP Update Activity',
      type: TOOL_TYPE.PREFIX_AND_AS,
    },
    {
      id: 'routing-history',
      name: 'Routing History',
      type: TOOL_TYPE.PREFIX_AND_AS,
    },
    {
      id: 'announced-prefixes',
      name: 'Announced Prefixes',
      type: TOOL_TYPE.AS,
    },
    { id: 'as-path-length', name: 'AS Path Length', type: TOOL_TYPE.AS },
    { id: 'asn-neighbours', name: 'ASN Neighbour', type: TOOL_TYPE.AS },
    {
      id: 'asn-neighbours-history',
      name: 'ASN Neighbours History',
      type: TOOL_TYPE.AS,
    },
    { id: 'prefix-count', name: 'Prefix Count', type: TOOL_TYPE.AS },
    { id: 'visibility', name: 'Visibility', type: TOOL_TYPE.PREFIX_AND_AS },
    {
      id: 'prefix-size-distribution',
      name: 'Prefix Size Distribution',
      type: TOOL_TYPE.AS,
    },
    {
      id: '-routing-consistency',
      name: 'AS/Prefix Routing Consistency',
      type: TOOL_TYPE.PREFIX_AND_AS,
    },
    { id: 'bgplay', name: 'BGPlay', type: TOOL_TYPE.PREFIX },
    {
      id: 'related-prefixes',
      name: 'Related Prefixes',
      type: TOOL_TYPE.PREFIX,
    },
    {
      id: 'upstream-visibility',
      name: 'Upstream visibility',
      type: TOOL_TYPE.PREFIX,
    },
    {
      id: 'caida-as-relationships',
      name: 'Caida AS Relationships',
      type: TOOL_TYPE.AS,
    },
  ],
  Database: [
    {
      id: '-overview',
      name: 'AS/Prefix Overview',
      type: TOOL_TYPE.PREFIX_AND_AS,
    },
    {
      id: '-routing-consistency',
      name: 'AS/Prefix Routing Consistency',
      type: TOOL_TYPE.PREFIX_AND_AS,
    },
  ],
  Activity: [
    {
      id: 'atlas-probes',
      name: 'RIPE Atlas Probes',
      type: TOOL_TYPE.PREFIX_AND_AS,
    },
    {
      id: 'atlas-targets',
      name: 'RIPE Atlas Measurement Targets',
      type: TOOL_TYPE.PREFIX_AND_AS,
    },
    {
      id: 'atlas-probe-deployment',
      name: 'RIPE Atlas Probe Deployment',
      type: TOOL_TYPE.AS,
    },
    {
      id: 'bandwidth',
      name: 'Observed Bandwidth Capacity',
      type: TOOL_TYPE.PREFIX,
    },
    {
      id: 'network-activity',
      name: 'Observed Network Activity',
      type: TOOL_TYPE.PREFIX,
    },
  ],
};
